<ul class="smart-button p-grid">
  @for (button of displayed().visible; track button.key) {
    <li smart-button-ui [data]="button"></li>
  }
</ul>

@if (displayed()?.list?.length > 0) {
  <ul class="smart-button-more">
    <li>
      <a class="icon-more-title" href="#" (click)="$event.preventDefault()">
        <i aria-hidden="true" class="icon-menu-more"></i>
      </a>
      <ul>
        @for (button of displayed().list; track button.key) {
          <li smart-button-ui [data]="button"></li>
        }
      </ul>
    </li>
  </ul>
}
